var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from 'react';
import styled from 'styled-components';
import isString from 'lodash/isString';
import _omit from 'lodash/omit';
import { createSelector } from 'reselect';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import { getColorBackgroundSelector, getColorGreySelector, getColorPrimarySelector, getColorErrorSelector } from '@signal/theme/selectors';
import { getColorTextSelector } from '@signal/theme';
import Input from '../Input';
import Typography from '../Typography';
import ArrowDown from '../Icons/ArrowDown';
var BORDER_RADIUS = '2px';
var borderColorSelector = createSelector(function (props) {
  return props.menuIsOpen;
}, function (props) {
  return props.hasValue;
}, function (props) {
  return props.error;
}, function (props) {
  return props.isDisabled;
}, getColorGreySelector(500), getColorGreySelector(300), getColorPrimarySelector(), getColorErrorSelector(), function (isOpen, isActive, isError, isDisabled, primaryGrey, secondaryGrey, colorPrimary, colorError) {
  return "\n      border-color: ".concat(isDisabled ? secondaryGrey : isError ? colorError : isOpen ? colorPrimary : isActive ? primaryGrey : secondaryGrey, ";\n    ");
});

var getWidth = function getWidth(_ref) {
  var width = _ref.width;

  if (isString(width) && width.length > 0) {
    return width;
  }

  return "".concat(width || 300, "px");
};

export var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n"])), getWidth);

var MenuListComponent = function MenuListComponent(_ref2) {
  var children = _ref2.children,
      className = _ref2.className;
  return /*#__PURE__*/React.createElement(MenuList, {
    className: className
  }, children);
};

export var StyledMenuList = styled(MenuListComponent)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 0;\n  background: ", ";\n  ", "\n  border-width: 1px;\n  border-style: solid;\n  border-top: none;\n  width: 100%;\n  box-sizing: border-box;\n  z-index: 1;\n  border-bottom-left-radius: ", ";\n  border-bottom-right-radius: ", ";\n"])), getColorBackgroundSelector(), borderColorSelector, BORDER_RADIUS, BORDER_RADIUS);
export var MenuListWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n"])));

var ArrowIcon = function ArrowIcon(_ref3) {
  var className = _ref3.className;
  return /*#__PURE__*/React.createElement(ArrowDown, {
    size: 15,
    className: className
  });
};

export var StyledArrowDown = styled(ArrowIcon)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  cursor: pointer;\n"])));
export var StyledValueContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  position: relative;\n  box-sizing: border-box;\n  flex: 1 1 0%;\n  overflow: hidden;\n  > div {\n    padding: 0;\n    margin: 0;\n  }\n"])));
var disabledColorSelector = getColorTextSelector('disabled');
var activeSelector = getColorTextSelector();
var colorSelector = getColorTextSelector('hint');
export var InputValueTextWrapper = styled.div.attrs(function (props) {
  return {
    color: props.isDisabled ? disabledColorSelector(props) : props.hasValue ? activeSelector(props) : colorSelector(props)
  };
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral([""])));
export var InputValueText = styled(Typography).attrs(function () {
  return {
    variant: 'subtitle1',
    color: 'inherit',
    noWrap: true
  };
})(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  margin-left: 2px;\n  margin-right: 2px;\n  max-width: calc(100% - 8px);\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  box-sizing: border-box;\n"])));
export var StyledMenuItem = styled(MenuItem)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  color: ", ";\n  background-color: ", ";\n  border-bottom: 1px solid ", ";\n\n  &:hover {\n    background-color: ", " !important;\n  }\n\n  &:last-child {\n    border-bottom: none;\n  }\n"])), getColorTextSelector('primary'), function (_ref4) {
  var isSelected = _ref4.isSelected;
  return isSelected ? getColorGreySelector(100) : 'inherit';
}, getColorGreySelector(100), getColorGreySelector(100));
export var MenuItemInner = styled(Typography).attrs(function () {
  return {
    variant: 'subtitle2',
    color: 'inherit',
    noWrap: true
  };
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral([""])));

var StyledInput = function StyledInput(props) {
  return /*#__PURE__*/React.createElement(Input, _omit(props, ['hasValue', 'menuIsOpen', 'isDisabled']));
};

export var InputField = styled(StyledInput)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  border-bottom: ", ";\n  border-radius: ", ";\n  ", "\n"])), function (_ref5) {
  var menuIsOpen = _ref5.menuIsOpen;
  return menuIsOpen ? 'none' : '1px solid';
}, function (_ref6) {
  var menuIsOpen = _ref6.menuIsOpen;
  return menuIsOpen ? "".concat(BORDER_RADIUS, " ").concat(BORDER_RADIUS, " 0 0") : BORDER_RADIUS;
}, borderColorSelector);
export var InputWrapper = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n"])));